export const desktop = {
  name: "desktop" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 5.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 .9.9V17a.9.9 0 0 1-.9.9H15a.9.9 0 1 1 0-1.8h5.6V6.4H3.4v9.7H12a.9.9 0 0 1 .9.9v3.1H16a.9.9 0 1 1 0 1.8H8a.9.9 0 1 1 0-1.8h3.1v-2.2H2.5a.9.9 0 0 1-.9-.9V5.5Z" clip-rule="evenodd"/></svg>`,
  keywords: ["desktop"],
  category: "device" as const,
};
